export default __webpack_public_path__ + "static/media/a011-01.92fbd8c7.jpg";